import { Alert, Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

type PropsUpdatePOMsConfirm = {
  sizeName: string;
  mcName: string;
  open: boolean;
  close: () => void;
  buzy: boolean;
  start: () => void;
};

export const UpdatePOMsConfirm: React.FC<PropsUpdatePOMsConfirm> = observer(
  (props) => {
    const { sizeName, mcName, open, close, buzy, start } = props;
    const msg = `Выбранные значения в колонке "New" будут перезаписаны в соответствующие point для размера "${sizeName}" в ${mcName}`;
    return (
      <Modal
        open={open}
        onCancel={close}
        okText="Обновить"
        closable={false}
        okButtonProps={{ loading: buzy }}
        onOk={start}
      >
        <Alert
          type="info"
          showIcon
          message="Обновить значения в MC?"
          description={msg}
        />
      </Modal>
    );
  },
);
